export const messages = {
  en: {
    adminCarDetail: {
      vehicleInfo: 'Vehicle Information',
      vehicleFee: 'Vehicle Fee',
      paymentRecord: 'Payment Record',
      modificationRecord: 'Modification Record',
      memberVehicle: 'Member Vehicle',
      ownerInfo: 'Owner Information',
      ownerHouse: 'Owner House',
      ownerVehicle: 'Owner Vehicle',
      licensePlateSync: 'License Plate Sync',
      parkingSpaceApplication: 'Parking Space Application',
      accessRecord: 'Access Record'
    },
    adminCarDetailInfo: {
      licensePlate: 'License Plate:',
      carBrand: 'Car Brand:',
      carType: 'Car Type:',
      color: 'Color:',
      plateType: 'Plate Type:',
      leaseStartTime: 'Lease Start Time:',
      leaseEndTime: 'Lease End Time:',
      validityPeriod: 'Validity Period:',
      remark: 'Remark:',
      parkingLot: 'Parking Lot:',
      parkingSpace: 'Parking Space:',
      status: 'Status:',
      relatedHouse: 'Related House:'
    },
    
    carDetailHis: {
      carNum: 'License Plate',
      leaseType: 'Plate Type',
      tempCar: 'Temporary Car',
      carType: 'Car Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      spaceReleased: 'Space Released',
      validPeriod: 'Valid Period',
      action: 'Action',
      operator: 'Operator',
      operateTime: 'Operate Time',
      add: 'Add',
      delete: 'Delete',
      modifyNew: 'Modify(New)',
      modifyOld: 'Modify(Old)'
    },
    carDetailMember: {
      carNum: 'License Plate',
      roomNum: 'Room Number',
      carBrand: 'Car Brand',
      carType: 'Car Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      parkingLot: 'Parking Lot',
      space: 'Space',
      none: 'None',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status'
    },
    carDetailOwner: {
      ownerFace: 'Owner Face',
      name: 'Name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      idCard: 'ID Card',
      address: 'Address',
      roomCount: 'Room Count',
      memberCount: 'Member Count',
      carCount: 'Car Count',
      complaintCount: 'Complaint',
      repairCount: 'Repair',
      oweFee: 'Owe Fee',
      contractCount: 'Contract',
      operation: 'Operation',
      detail: 'Detail'
    },
    aRoomDetailCar: {
      placeholderCarNum: 'Please enter license plate number',
      carNum: 'License Plate',
      leaseType: 'Plate Type',
      tempCar: 'Temporary Car',
      carType: 'Vehicle Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      released: 'Released',
      validity: 'Validity'
    },
    carDetailTransaction: {
      syncId: 'Sync ID',
      deviceCode: 'Device Code',
      objectType: 'Object Type',
      objectName: 'Object Name',
      command: 'Command',
      status: 'Status',
      remark: 'Remark',
      syncTime: 'Sync Time'
    },
    carDetailApply: {
      applyId: 'Apply ID',
      carNum: 'License Plate',
      parkingSpace: 'Parking Space',
      parkingLot: 'Parking Lot',
      space: 'Space',
      none: 'None',
      carBrand: 'Car Brand',
      carType: 'Car Type',
      color: 'Color',
      startTime: 'Start Time',
      endTime: 'End Time',
      applicant: 'Applicant',
      phone: 'Phone',
      result: 'Result',
      pendingReview: 'Pending Review',
      pendingPayment: 'Pending Payment',
      completed: 'Completed',
      reviewFailed: 'Review Failed',
      abnormalStatus: 'Abnormal Status',
      familyCar: 'Family Car',
      bus: 'Bus',
      truck: 'Truck',
      abnormalCar: 'Abnormal Car'
    },
    aCarDetailCarInout: {
      entryImage: 'Entry Image',
      inoutNumber: 'In/Out Number',
      vehicleStatus: 'Vehicle Status',
      plateNumber: 'Plate Number',
      parkingLot: 'Parking Lot',
      billingRule: 'Billing Rule',
      plateType: 'Plate Type',
      entryTime: 'Entry Time',
      exitTime: 'Exit Time',
      parkingTime: 'Parking Time',
      chargeAmount: 'Charge Amount',
      remark: 'Remark',
      entry: 'Entry',
      exit: 'Exit',
      hour: 'hour',
      minute: 'min'
    }
  },
  zh: {
    adminCarDetail: {
      vehicleInfo: '车辆信息',
      vehicleFee: '车辆费用',
      paymentRecord: '缴费记录',
      modificationRecord: '修改记录',
      memberVehicle: '成员车辆',
      ownerInfo: '业主信息',
      ownerHouse: '业主房屋',
      ownerVehicle: '业主车辆',
      licensePlateSync: '车牌同步',
      parkingSpaceApplication: '车位申请',
      accessRecord: '出入场记录'
    },
    adminCarDetailInfo: {
      licensePlate: '车牌号：',
      carBrand: '车品牌：',
      carType: '车类型：',
      color: '颜色：',
      plateType: '车牌类型：',
      leaseStartTime: '起租时间：',
      leaseEndTime: '结租时间：',
      validityPeriod: '有效期：',
      remark: '备注：',
      parkingLot: '停车场：',
      parkingSpace: '车位：',
      status: '状态：',
      relatedHouse: '关联房屋：'
    },
    
    carDetailHis: {
      carNum: '车牌号',
      leaseType: '车牌类型',
      tempCar: '临时车',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      spaceReleased: '车位已释放',
      validPeriod: '有效期',
      action: '动作',
      operator: '操作人',
      operateTime: '操作时间',
      add: '添加',
      delete: '删除',
      modifyNew: '修改(新)',
      modifyOld: '修改(旧)'
    },
    carDetailMember: {
      carNum: '车牌号',
      roomNum: '房屋号',
      carBrand: '车辆品牌',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      parkingLot: '车场',
      space: '车位',
      none: '无',
      startTime: '起租时间',
      endTime: '截止时间',
      status: '状态'
    },
    carDetailOwner: {
      ownerFace: '业主人脸',
      name: '姓名',
      gender: '性别',
      male: '男',
      female: '女',
      idCard: '身份证',
      address: '家庭住址',
      roomCount: '房屋数',
      memberCount: '业主成员',
      carCount: '车辆数',
      complaintCount: '投诉',
      repairCount: '报修',
      oweFee: '欠费',
      contractCount: '业主合同',
      operation: '操作',
      detail: '详情'
    },
    aRoomDetailCar: {
      placeholderCarNum: '请填写车牌号',
      carNum: '车牌号',
      leaseType: '车牌类型',
      tempCar: '临时车',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      released: '车位已释放',
      validity: '有效期'
    },
    carDetailTransaction: {
      syncId: '同步ID',
      deviceCode: '设备编码',
      objectType: '对象类型',
      objectName: '对象名称',
      command: '指令',
      status: '状态',
      remark: '说明',
      syncTime: '同步时间'
    },
    carDetailApply: {
      applyId: '申请ID',
      carNum: '车牌号',
      parkingSpace: '停车位',
      parkingLot: '停车场',
      space: '停车位',
      none: '无',
      carBrand: '汽车品牌',
      carType: '车辆类型',
      color: '颜色',
      startTime: '起租时间',
      endTime: '结租时间',
      applicant: '申请人',
      phone: '手机号',
      result: '审核结果',
      pendingReview: '待审核',
      pendingPayment: '待缴费',
      completed: '完成',
      reviewFailed: '审核失败',
      abnormalStatus: '状态异常',
      familyCar: '家用小汽车',
      bus: '客车',
      truck: '货车',
      abnormalCar: '异常车辆'
    },
    aCarDetailCarInout: {
      entryImage: '进场图',
      inoutNumber: '进出场编号',
      vehicleStatus: '车辆状态',
      plateNumber: '车牌号',
      parkingLot: '停车场',
      billingRule: '计费规则',
      plateType: '车牌类型',
      entryTime: '进场时间',
      exitTime: '出场时间',
      parkingTime: '停车时间',
      chargeAmount: '收费金额',
      remark: '说明',
      entry: '进场',
      exit: '出场',
      hour: '小时',
      minute: '分'
    }
  }
}